import { SortItem } from './member.dashboard.license.response';

export class VendorStatisticsItem {

    Count: number;
    VendorItemID: number;
    DateTimeCreated: Date;
    FileName: string;
    ItemLabel: string;
    VendorName: string;

    public static FixDates(item: VendorStatisticsItem) {
        item.DateTimeCreated = new Date(item.DateTimeCreated);
    }

}

export class VendorStatisticsItemArray extends Array<VendorStatisticsItem> {
    public LastSort: SortItem;

    constructor(...items: VendorStatisticsItem[]) {
        super(...items);
        Object.setPrototypeOf(this, VendorStatisticsItemArray.prototype);
    }

    public static FixDates(items: VendorStatisticsItemArray) {
        items.forEach(x => VendorStatisticsItem.FixDates(x));
    }

}
